import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  //template: '<alert></alert><router-outlet></router-outlet>',
  template: '<alert></alert><router-outlet></router-outlet>',
})
export class SimpleLayoutComponent { }
